import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const GENERATE_EVENT_FINANCIAL_QUERY = print(gql`
  mutation GenerateEventFinancial($data: GenerateEventFinancialInput!) {
    generateEventFinancial(data: $data) {
      eCommerceProductId
      eCommerceControlSKUId
      eCommerceSkuId
      eCommerceLastUpdate
      active
    }
  }
`);

export interface GenerateEventFinancialGql {
  generateEventFinancial: {
    eCommerceProductId: number;
    eCommerceControlSKUId: number;
    eCommerceSkuId: number;
    eCommerceLastUpdate: string;
    active: boolean;
  };
}
